import { createLogic } from "redux-logic";
import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";

import * as ActionTypes from "../../actions/actionTypes";
import * as AppsActions from "../../actions/appsActions";
import * as ControlPanelActions from "../../actions/controlPanelActions";
import * as constants from "../../constants";

const loadUsersLogic = createLogic({
	type: ActionTypes.LOAD_APP_NAVIGATION,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		firebase
			.auth()
			.currentUser.getIdToken(true)
			.then(token => {
				var api = axios.create({
					baseURL: constants.BASE_API_URL,
					timeout: 20000,
					headers: { Authorization: "Bearer " + token },
				});
				api.get(`/apps/${action.appKey}/navigation`)
					.then(data => {
						dispatch(AppsActions.loadAppNavigationSuccess(data.data));
						if (action.callback) {
							//This tells the component that the app nav has actually been loaded into state and can be used to initialize the form
							setTimeout(() => {
								action.callback();
							}, 200);
						}
						done();
					})
					.catch(error => {
						dispatch(ControlPanelActions.displayError(error.message));
						done();
					});
			});
	},
});

export default [loadUsersLogic];
